import React from 'react';
import { StackItem } from '@domain-group/fe-blueprint-ui/layout';
import RmaLogo from '../recommendations/rma-logo';
import RmaLogoV2 from '../recommendations/rma-logo-v2';
import { STAR_RATING_SECTION } from './index';
import * as styles from './average-star-rating-and-total.style';

interface TotalReviewsTextProps {
  totalReviews: number;
  section: STAR_RATING_SECTION;
  isMobile: boolean;
  scrollTo?: boolean;
  handleScroll?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  testIdPrefix?: string;
}

const getRmaLogo = (section: STAR_RATING_SECTION): JSX.Element | string => {
  if (
    section === STAR_RATING_SECTION.HERO ||
    section === STAR_RATING_SECTION.STICKY
  ) {
    return <RmaLogoV2 height={22} marginLeft={2} marginBottom={4} />;
  }
  if (
    section === STAR_RATING_SECTION.MOBILE ||
    section === STAR_RATING_SECTION.AGENT_CARDS_DARK ||
    section === STAR_RATING_SECTION.AGENT_CARDS ||
    section === STAR_RATING_SECTION.AGENT_CARDS_NEUTRAL ||
    section === STAR_RATING_SECTION.AGENCY_CARD ||
    section === STAR_RATING_SECTION.AGENCY_PROPERTY_SUMMARY ||
    section === STAR_RATING_SECTION.SIDEBAR
  ) {
    return <RmaLogo height={22} marginLeft={2} marginTop={4} />;
  }
  return 'RateMyAgent';
};

const TotalReviewsText: React.FC<TotalReviewsTextProps> = ({
  totalReviews,
  section,
  isMobile,
  scrollTo = false,
  handleScroll,
  testIdPrefix = '',
}) => (
  <StackItem
    css={[styles.totalReview(section), styles.scrollToReview(scrollTo)]}
    align={isMobile ? 'center' : 'end'}
    data-testid={`${testIdPrefix}total-rating`}
    id={`${testIdPrefix}total-rating`}
    as="span"
    onClick={scrollTo ? handleScroll : undefined}
  >
    <span css={styles.starAndReviews(section)}>
      <span css={styles.seperator(section)}>|</span>
      {totalReviews} {totalReviews === 1 ? 'review' : 'reviews'} from{' '}
      {getRmaLogo(section)}
    </span>
  </StackItem>
);

export default TotalReviewsText;
